module.exports = "/_next/static/images/video_id_7138183995669368106-306c75e38f2ad77e1dd68c9c48328b1e.jpg";